"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FoxInputEmail = _interopRequireDefault(require("../components/FoxInputEmail"));

var _wrapFormField = _interopRequireDefault(require("./wrapFormField"));

var _asReduxFormField = _interopRequireDefault(require("./asReduxFormField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _wrapFormField.default)((0, _asReduxFormField.default)(_FoxInputEmail.default));

exports.default = _default;